import { useLang } from 'hooks/lang';

import { Row, Card, Tooltip, Column } from 'components/Blocks';
import { DownloadFileButton } from 'components/Buttons';
import { UserAvatar } from 'components/UserAvatar';

import { FileUpIcon } from 'components/Icons';

import { usePackage } from './context';

import { fixFileName, getFirstAndLastName } from 'utils/text';
import { dateDistanceToNow, formatPublishedAtDate } from 'utils/date';

export function PackageFiles(): JSX.Element {
  const { t } = useLang();

  const { data } = usePackage();

  const files = [data.proofFile, ...data.complementaryFiles];

  return (
    <Column>
      <h6 className="text-xl font-medium">{t('files')}</h6>

      {files.map((file) => (
        <Card flow="row" key={file.id} className="phone:grid phone:grid-cols-2">
          <Row className="w-[240px]">
            <UserAvatar user={file.uploadedBy} className="phone:!h-8 phone:!w-8" />

            <span className="font-medium phone:text-sm">
              {getFirstAndLastName(file.uploadedBy.name)}
            </span>
          </Row>

          <Row gap="2" className="grow phone:col-span-2 phone:row-start-1">
            <FileUpIcon color="primary" />

            <span className="font-medium text-primary">{fixFileName(file.name)}</span>
          </Row>

          <Row className="ml-auto">
            <DownloadFileButton {...file} />

            <Tooltip content={formatPublishedAtDate(file.uploadedAt)}>
              <span className="text-sm font-medium phone:text-xs">
                {dateDistanceToNow(file.uploadedAt)}
              </span>
            </Tooltip>
          </Row>
        </Card>
      ))}
    </Column>
  );
}
